@if (name === activeStep) {
  <ng-content></ng-content>
}
